import { render, staticRenderFns } from "./Resturant.vue?vue&type=template&id=a0ae89de&"
import script from "./Resturant.vue?vue&type=script&lang=js&"
export * from "./Resturant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports